// Auditlogboek van de lezer. Regels worden verzameld en in porties naar de databasefunctie lezer_log gestuurd;
// de server zet er zelf tijd en afzender bij. De inlogmomenten komen apart uit het inlogsysteem (lezer_inlogs).
import { supabase } from "../supabase";

const MAX_WACHTRIJ = 200;
const PORTIE = 50;
let wachtrij = [];
let sessie = null;
let timer = null;
let bezig = false;

export function sessieId() {
  if (sessie) return sessie;
  try { sessie = sessionStorage.getItem("os_lezer_sessie"); } catch (e) { /* stil */ }
  if (!sessie) {
    sessie = (typeof crypto !== "undefined" && crypto.randomUUID) ? crypto.randomUUID() : String(Date.now()) + Math.random().toString(36).slice(2);
    try { sessionStorage.setItem("os_lezer_sessie", sessie); } catch (e) { /* stil */ }
    logLezer("login", (navigator.userAgent || "").slice(0, 160));
  }
  return sessie;
}

export function logLezer(soort, detail) {
  wachtrij.push({ soort, detail: String(detail || "").slice(0, 300) });
  if (wachtrij.length > MAX_WACHTRIJ) wachtrij = wachtrij.slice(-MAX_WACHTRIJ);
  if (!timer) timer = setTimeout(() => { timer = null; leegLogboek(); }, 6000);
}

export async function leegLogboek() {
  if (bezig || !wachtrij.length) return;
  bezig = true;
  const portie = wachtrij.slice(0, PORTIE);
  try {
    const { error } = await supabase.rpc("lezer_log", { p_sessie: sessieId(), p_items: portie });
    if (!error) wachtrij = wachtrij.slice(portie.length);
  } catch (e) { /* blijft in de wachtrij voor de volgende poging */ }
  bezig = false;
  if (wachtrij.length && !timer) timer = setTimeout(() => { timer = null; leegLogboek(); }, 6000);
}

export function nieuweSessieNaUitloggen() {
  sessie = null;
  try { sessionStorage.removeItem("os_lezer_sessie"); } catch (e) { /* stil */ }
}

// Hartslag: elke minuut een regel (soort "venster") zolang het venster zichtbaar is. Zo ziet Furgel of de lezer online is.
export function startHartslag() {
  const tik = () => { if (document.visibilityState === "visible") logLezer("venster", "hartslag"); };
  tik();
  const t = setInterval(tik, 60000);
  return () => clearInterval(t);
}
